
import { CoverSection } from '../components/aboutUsPage/coverSection/CoverSection';
import { MainSection } from '../components/aboutUsPage/mainSection/MainSection';

export function AboutUsPage() {
  return (
    <>
      <CoverSection />
      <MainSection />
    </>
  );
}
